// extracted by mini-css-extract-plugin
module.exports = {"definitions":"PeerDefinition__definitions__BqTFr","definitionTitle":"PeerDefinition__definitionTitle__YXdVX","definitionBody":"PeerDefinition__definitionBody__Mq23Y"};